import Modal from "../Modal"
import { createUseStyles } from 'react-jss'
import { useEffect, useState } from "react"
import { PayrollValidationError } from "../../redux/types"
import PayrollFileValidationErrorList from "./PayrollFileValidationErrorList"
import { useTranslation } from "react-i18next"

interface Props {
    visible: boolean
    errors: PayrollValidationError[]
    onCloseClick: () => void
}

const PayrollFileErrorsModal = ({ visible, errors, onCloseClick}: Props) => {
    const styles = useStyles()
    const { t } = useTranslation(['common', 'payrolls']);

    const [pageIndex, setPageIndex] = useState<number>(1)

    useEffect(() => {
        setPageIndex(1)
    }, [errors])

    const handleOnClose = () => {
        onCloseClick()
    }

    return (
        <Modal
            size='xl'
            title={t('payrollValidationErrors', {ns: 'payrolls'})}
            visible={visible}
            okButtonTitle={t('close', {ns: 'common'})}
            hideCancelButton={true}
            onHide={handleOnClose}
            onOkClick={handleOnClose}
            onCancelClick={handleOnClose}
        >
            <div className={styles.container}>
               <PayrollFileValidationErrorList 
                    pageIndex={pageIndex}
                    pageSize={3}
                    errors={errors}
                    onPageChange={(pageIndex: number) => setPageIndex(pageIndex)}
               />
            </div>
        </Modal>
    )
}

export default PayrollFileErrorsModal

const useStyles = createUseStyles({
    container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
    },
})